/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'sec-searchblack': {
    width: 11,
    height: 12,
    viewBox: '0 0 11 12',
    data: '<g transform="translate(1 1)" _stroke="#000" _fill="none" fill-rule="evenodd" stroke-linejoin="round"><circle pid="0" cx="3.75" cy="3.75" r="3.75"/><path pid="1" d="M6.367 6.42L9.7 9.545 6.367 6.42z" stroke-linecap="round"/></g>'
  }
})
